// 职位列表
export function getList() {
  return axios({
    url: `/api/jobs`,
    method: "get",
  });
}
